import {
    gsap
  } from "gsap/dist/gsap";
  import {
    ScrollTrigger
  } from "gsap/dist/ScrollTrigger";
  import {
    ScrollToPlugin
  } from "gsap/dist/ScrollToPlugin";

  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
const mainContent = document.getElementById('site');
const preLoaderEl = document.querySelector('.preloader');
const headerBar = mainContent.querySelector('#masthead');
var headerBarAnimate = gsap.timeline({
	paused: false, // default is false
	smoothChildTiming: true,
});
headerBarAnimate
	.fromTo(
	headerBar, {
		opacity: 0,
		}, {
			opacity: 1,
			duration: 0.5,
		},
	 "<.2")
	.fromTo(headerBar, {
		scale: 0.95
	}, {
		scale: 1,
		duration: 1
	}, "<.1");

  let timelineResourcesHero = gsap.timeline({
    paused: true, // default is false
    defaults: { // children inherit these defaults
        duration: 1.5,
        ease: "power2.out"
    },
    smoothChildTiming: true,
    });
    timelineResourcesHero.fromTo('.top-page-ornament',{
        opacity:0,
        scale:0.6
    },{
        opacity:1,
        scale:1,
    },'<.1')
    
    .fromTo('.titleRes',{
     scale:0.7,
     opacity:0
    },{ 
      scale:1,
      opacity:1,
      stagger:.1
    },'<.1')
    .fromTo('.resource-types',{
     scale:0.7,
     opacity:0
    },{ 
      scale:1,
      opacity:1,
      stagger:.1
    },'<.1')
    .fromTo('.dribble-media-linked figure',{
        scale:0.9,
        opacity:0
    },{
        scale:1,
        opacity:1
    },'<1')
    .fromTo('.blogitem',{
        scale:0.7,
        opacity:0
    },{ 
        scale:1,
        opacity:1,
        stagger:.1  
    },'<.1')
    .fromTo('.top-meta',{
        scale:0.7,
        opacity:0
    },{
        scale:1,
        opacity:1
    },'<.1')
    .fromTo('.resources-content-wrapper h2',{
        scale:0.7,
        opacity:0
    },{
        scale:1,
        opacity:1
    },'<.1')

    document.addEventListener("DOMContentLoaded", function () {
    
        if (preLoaderEl) {
            setTimeout(function () {
                window.scroll({
                    top: 0, 
                    left: 0, 
                    behavior: 'smooth'
                  });
                preLoaderEl.classList.add('hide');
                mainContent.classList.remove('overflow-hidden');
                mainContent.classList.remove('opacity-0');
                mainContent.classList.add('opacity-100');
            }, 1300);
        }
        

        setTimeout(function(){
            headerBarAnimate.play();
            timelineResourcesHero.play();
        }, 1300);
    })

    let timelineLatestArticle = gsap.timeline({
        scrollTrigger:'.resources-latest',
        paused: false, // default is false
        defaults: { // children inherit these defaults
            duration: 1.5,
            ease: "power2.out"
        },
        smoothChildTiming: true,
        });
        timelineLatestArticle.fromTo('.resource-blog ',{
            scaleX:0.6,
            transformOrigin: 'center'
        },{
            scaleX:1,
            stagger:.2,
            transformOrigin: 'center'
        },"<.1")



var selectedType = 'blog';
const resourceTypesButton = document.querySelectorAll('.resource-types button');
const resourceContents = document.querySelectorAll('.resources-content-wrapper');
if (resourceTypesButton) {
    resourceTypesButton.forEach((el, i) => {
        el.addEventListener('click', function(el){
            resourceTypesButton.forEach(btnEl => btnEl.classList.remove('resource-type-selected'));
            el.target.classList.add('resource-type-selected');

            resourceContents.forEach((elContent, i) => {
                if (elContent.classList.contains('resources-content__' + el.target.dataset.resourceType)) {
                    elContent.classList.add('resource-content__show');
                    elContent.classList.remove('resource-content__hidden');
                }else{
                    elContent.classList.remove('resource-content__show');
                    elContent.classList.add('resource-content__hidden');
                }
            });
        });
    });
}


// const leftImages = document.querySelectorAll('.leftImage');
// const rightImages = document.querySelectorAll('.rightImage');

// // Function to handle scroll event
// function leftHandleScroll() {
//   leftImages.forEach(image => {
//     const rect = image.getBoundingClientRect();
//     const translateY = window.scrollY - rect.top;

//     // Apply the transform based on scroll direction
//     gsap.to(image, {
//       x: translateY > 0 ? -translateY / 10 : 0, // Adjust the division value to control the amount of movement
//       ease: 'none'
//     });
//   });
// }

// // Attach the scroll event listener
// window.addEventListener('scroll', leftHandleScroll);


// function rightHandleScroll() {
//   rightImages.forEach(image => {
//     const rect = image.getBoundingClientRect();
//     const translateY = window.scrollY - rect.top;

//     // Apply the transform based on scroll direction
//     gsap.to(image, {
//       x: translateY > 0 ? translateY / 10 : 0, // Adjust the division value to control the amount of movement
//       ease: 'none'
//     });
//   });
// }

// // Attach the scroll event listener
// window.addEventListener('scroll', rightHandleScroll);